import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { REPORT_TYPES } from "../../../pages/reports/constants";

export const DAILY_FOR_OVERLIMIT_REDUCER_NAME = "dfo-report";

const initialState = {
  page: 0,
  size: 20,
  totalCount: 0,
  reports: [],
  filters: {
    limit: "",
    product: "",
    sumAboveTheLimit: "",
    transactionType: "",
    forExport: false,
    type: REPORT_TYPES.DAILY,
  },
  enabled: false,
};

const dailyForOverlimitSlice = createSlice({
  name: DAILY_FOR_OVERLIMIT_REDUCER_NAME,
  initialState,
  reducers: {
    setPageDailyForOverlimit: (state, { payload }) => {
      state.page = parseInt(payload, 10);
    },
    setSizeDailyForOverlimit: (state, { payload }) => {
      state.size = parseInt(payload, 10);
    },
    setTotalCountDailyForOverlimit: (state, { payload }) => {
      state.totalCount = parseInt(payload, 10);
    },
    setReportsDailyForOverlimit: (state, { payload }) => {
      state.reports = [...payload];
    },
    setFiltersDailyForOverlimit: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
    },
    setEnabledQueryDailyForOverlimit: (state, { payload }) => {
      state.enabled = payload;
    },
    clearDailyForOverlimitReports: (state) => {
      state.page = initialState.page;
      state.size = initialState.size;
      state.totalCount = initialState.totalCount;
      state.filters = { ...initialState.filters };
      state.reports = initialState.reports;
      state.enabled = initialState.enabled;
    },
    applyFiltersAndEnableDailyForOverlimit: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
      state.page = 0;
      state.size = 20;
      state.enabled = true;
    },
  },
});

export default dailyForOverlimitSlice.reducer;

export const {
  setPageDailyForOverlimit,
  setSizeDailyForOverlimit,
  setTotalCountDailyForOverlimit,
  setReportsDailyForOverlimit,
  setFiltersDailyForOverlimit,
  setEnabledQueryDailyForOverlimit,
  clearDailyForOverlimitReports,
  applyFiltersAndEnableDailyForOverlimit,
} = dailyForOverlimitSlice.actions;

export const useSelectFiltersDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].filters);

export const useSelectPageDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].page);

export const useSelectSizeDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].size);

export const useSelectTotalCountDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].totalCount);

export const useSelectReportsDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].reports);

export const useSelectEnabledDailyForOverlimit = () =>
  useSelector((state) => state[DAILY_FOR_OVERLIMIT_REDUCER_NAME].enabled);
